// src/games/pacman-Space/systems/AudioSystem.ts
import {
  AudioSystem as SharedAudioSystem,
  AudioConfig,
} from '../../../engine/ecs/systems/AudioSystem';
import { ResourceManager } from '../../../engine/resources/ResourceManager';

// Space-specific audio configuration
const SPACE_AUDIO_CONFIG: AudioConfig = {
  // superpowerBackgroundMusic: 'super_power_background.wav', // No longer needed - default matches!
  soundVolume: 0.5, // Quieter for space theme
  musicVolume: 0.3,
  enableSuperpowerMusic: true,
  enableSoundEffects: true,
  enableBackgroundMusic: true,
};

export class AudioSystem extends SharedAudioSystem {
  constructor(resourceManager: ResourceManager) {
    super(resourceManager, SPACE_AUDIO_CONFIG);
  }
}
